import { ErrorHandler, Injectable} from '@angular/core';
import {GoogleAnalyticsService} from './google-analytics.service';
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private googleAnalyticsService: GoogleAnalyticsService) { }
  handleError(error) {

    // console.log(error);
    // console.log(error.toString())
    console.log(error.stack);
    const errorMessage = error.stack != null ? error.stack : JSON.stringify(error);
    this.googleAnalyticsService.addError('web-cli: ' + errorMessage, true);
    // IMPORTANT: Rethrow the error otherwise it gets swallowed
    throw error;
  }
}
